//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbBanner from '@/elements/editorial/rb-banner/rb-banner.vue'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { createNamespacedHelpers } from 'vuex'
import htmlFragment from '@/elements/html-fragment/html-fragment'
const { mapGetters: mapGettersPlp } = createNamespacedHelpers('plp')
export default {
  name: 'rb-plp-hero-banner',
  components: {
    htmlFragment,
    RbBanner,
  },
  props: {
    messageColor: {
      type: String,
      default: 'dark',
    },
    componentNoBg: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['isPlpExclusive'],
  computed: {
    ...mapGettersPlp(['getSeoConf']),
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
  },
}
